import { colors } from '@mui/material';
import { COLORS } from '@consts/general';

export default {
    primary: {
        contrastText: COLORS.WHITE,
        dark: COLORS.BLUE_DARK,
        main: COLORS.BLUE,
        light: COLORS.BLUE_LIGHT,
    },
    secondary: {
        contrastText: COLORS.WHITE,
        dark: colors.blue[900],
        main: '#696b6e',
        light: colors.blue.A400,
    },
    orange: {
        main: COLORS.ORANGE,
        contrastText: COLORS.WHITE,
    },
    error: {
        contrastText: COLORS.WHITE,
        dark: COLORS.RED_DARK,
        main: COLORS.RED,
        light: COLORS.RED_LIGHT,
    },
    text: {
        primary: '#696b6e',
        secondary: COLORS.BLUE,
        link: COLORS.BLUE,
    },
    link: colors.blue[800],
    icon: colors.blueGrey[600],
    background: {
        default: '#F4F6F8',
        paper: COLORS.WHITE,
    },
    divider: colors.grey[200],
    white: '#fff',
    black: '#000',
};
